import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { ListResponse, PathParamsWithId, ResponseWithId } from "commons/types/api/common";

import { CollectionBody, CollectionDetails, CollectionListItem } from "types/api/collection";

import { AdvancedListRequest } from "types/api/commons";

function useCollectionApi() {
    const { get, del, post, put } = useHttpManaged();
    const getAllCollection = React.useCallback((queryParams: AdvancedListRequest, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ListResponse<CollectionListItem>> => {
        return get<undefined, AdvancedListRequest, ListResponse<CollectionListItem>>({
            url: "/collection",
            queryParams: queryParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const getOneCollection = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<CollectionDetails> => {
        return get<PathParamsWithId, undefined, CollectionDetails>({
            url: "/collection/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const createCollection = React.useCallback((body: CollectionBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ResponseWithId> => {
        return post<undefined, undefined, CollectionBody, ResponseWithId>({
            url: "/collection",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const updateCollection = React.useCallback((pathParams: PathParamsWithId, body: CollectionBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return put<PathParamsWithId, undefined, CollectionBody, null>({
            url: "/collection/:id",
            pathParams: pathParams,
            body: body,
            options: options,
            headers: headers
        });
    }, [put]);
    const deleteCollection = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/collection/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        getAllCollection,
        getOneCollection,
        createCollection,
        updateCollection,
        deleteCollection
    };
}

export default useCollectionApi;